/*
================================================================================
File: src/utils/formatters.js
Description: Contains utility functions for formatting data.
================================================================================
*/
export const getFirstLetters = (str) => {
  if (!str) return '';
  return str
    .split(" ")
    .map((word) => word.charAt(0))
    .join("");
};

export const formatMobileNumber = (text) => {
  if (!text) return '';
  const cleaned = `${text}`.replace(/\D/g, "");
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    const intlCode = match[1] ? "+1 " : "";
    return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("");
  }
  return text;
};

export const dayCounter = (text) => {
  const dayMap = {
    86400: "1 Day", 172800: "2 Days", 259200: "3 Days", 345600: "4 Days",
    432000: "5 Days", 604800: "1 Week", 2592000: "1 Month",
  };
  return dayMap[text] || "1 Day";
};

export const convertSecondsToMessage = (secs) => {
  const seconds = parseInt(secs, 10);
  if (seconds === 0) return "Send e-mail Immediately";
  const days = Math.floor(seconds / 86400);
  if (days >= 365) return `Send ${Math.floor(days / 365)} year(s) after initial message`;
  if (days >= 30) return `Send ${Math.floor(days / 30)} month(s) after initial message`;
  if (days >= 7) return `Send ${Math.floor(days / 7)} week(s) after initial message`;
  if (days >= 1) return `Send ${days} day(s) after initial message`;
  return `Send ${seconds} second(s) after initial message`;
};